import React from 'react'

import { TableHeaderCell } from '../../lib/table'

export type ActiveSortedHeaderProps = {
    parameter: string
    reversed: boolean
}

type SortedHeaderProps = {
    filter: ActiveSortedHeaderProps
    sortType: string
    text: string
    setSortParams: (sortType: string) => void
}

const SortedHeader = ({ filter, sortType, text, setSortParams }: SortedHeaderProps) => {
    return (
        <TableHeaderCell>
            <a
                onClick={() => setSortParams(sortType)}
                className="pointer w-full flex gap-1 justify-content-between align-items-center"
            >
                {text}
                {filter.parameter && filter?.parameter === sortType && (
                    <span className={`fa fa-caret-${filter.reversed ? 'up' : 'down'}`} />
                )}
            </a>
        </TableHeaderCell>
    )
}

export default SortedHeader
